import { Component, computed, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { WorkshopService } from '../../../api/workshop/workshop.service';
import { WorkshopCatalogueHeaderComponent } from './workshop-catalogue-header/workshop-catalogue-header.component';
import { CourseCatalogueDetailsCardComponent } from '../../courses/course-catalogue-detail/course-catalogue-details-card/course-catalogue-details-card.component';
import { MatIconModule } from '@angular/material/icon';
import { CurrencyPipe } from '@angular/common';
import { extractPeriodLabel } from '../../../util/date';
import { FaqEntryComponent } from '../../faq/faq-entry/faq-entry.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { FaqEntry } from '../../faq/faq.interfaces';
import { afterSchoolWorkshopFaqData } from '../../faq/faq.data';
import { FrontendShareSocialsComponent } from '../../_layout/frontend-share-socials/frontend-share-socials.component';
import { WorkshopCatalogueDetailScheduleComponent } from './workshop-catalogue-details-schedule/workshop-catalogue-detail-schedule.component';
import { canRegisterForWorkshop } from '../../../api/workshop/workshop.util';
import { MatTooltipModule } from '@angular/material/tooltip';
import { i18nRouterLinkDirective } from '../../../util/router/i18n-router-link.directive';
import { Workshop } from '../../../api/workshop/workshop.model';

@Component({
  selector: 'app-workshop-catalogue-detail',
  standalone: true,
  templateUrl: './workshop-catalogue-detail.component.html',
  imports: [
    WorkshopCatalogueHeaderComponent,
    CourseCatalogueDetailsCardComponent,
    WorkshopCatalogueDetailScheduleComponent,
    MatIconModule,
    MatTooltipModule,
    CurrencyPipe,
    FaqEntryComponent,
    MatExpansionModule,
    FrontendShareSocialsComponent,
    MatTooltipModule,
    i18nRouterLinkDirective,
  ],
})
export class WorkshopCatalogueDetailComponent {
  protected readonly resourceService = inject(WorkshopService);
  protected readonly route = inject(ActivatedRoute);
  protected readonly workshop = toSignal(
    this.route.data.pipe(map((data) => data['workshop'] as Workshop)),
  );
  protected readonly label = computed(() => this.workshop()?.theme.name || '');
  protected readonly period = computed(() =>
    extractPeriodLabel(this.workshop()?.schedule),
  );
  protected readonly faqEntries: FaqEntry[] = afterSchoolWorkshopFaqData();

  isWorkshopAvailable = computed(() => {
    const workshop = this.workshop();
    return workshop && canRegisterForWorkshop(workshop);
  });
  tooltipText = computed(() => {
    if (this.workshop()?.full) return $localize`Fully booked`;
    if (!this.isWorkshopAvailable()) return $localize`Registrations closed`;
    return '';
  });

  scrollToSection($event: any) {
    const element = document.getElementById($event);
    if (element)
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });
  }
}
